import { Mail, Download } from "lucide-react";
import { useMessages } from "@/hooks/useMessages";
import MessageRow from "@/components/admin/MessageRow";

export const MessagesInbox = ({ pin }) => {
  const {
    messages, unread, loading, openId, filter, setFilter,
    setRead, remove, toggleLead, toggleOpen, exportCsv, visible, tabs,
  } = useMessages(pin);

  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.03] p-5" data-testid="admin-messages">
      <div className="flex items-center justify-between">
        <h2 className="font-head font-bold text-lg flex items-center gap-2">
          <Mail className="h-4 w-4 text-amber-400" /> Contact Messages
          {unread > 0 && (
            <span data-testid="messages-unread-badge" className="ml-1 text-xs font-semibold bg-amber-500/20 text-amber-300 px-2 py-0.5 rounded-full">
              {unread} new
            </span>
          )}
        </h2>
        <div className="flex items-center gap-3">
          <span className="text-xs text-zinc-500">{messages.length} total</span>
          {messages.length > 0 && (
            <button
              type="button"
              onClick={exportCsv}
              data-testid="messages-export-csv"
              className="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-md bg-white/5 hover:bg-white/10 text-zinc-300 hover:text-white transition-colors"
              title={filter === "leads" ? "Export flagged leads to CSV" : "Export all messages to CSV"}
            >
              <Download className="h-3.5 w-3.5" /> Export {filter === "leads" ? "leads" : "CSV"}
            </button>
          )}
        </div>
      </div>

      <div className="mt-3 flex items-center gap-1.5" data-testid="messages-filter-tabs">
        {tabs.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setFilter(t.key)}
            data-testid={`messages-filter-${t.key}`}
            className={`text-xs font-medium px-2.5 py-1 rounded-full transition-colors ${
              filter === t.key
                ? "bg-blue-600 text-white"
                : "bg-white/5 text-zinc-400 hover:bg-white/10 hover:text-zinc-200"
            }`}
          >
            {t.label} <span className="opacity-70">{t.count}</span>
          </button>
        ))}
      </div>

      <div className="mt-4 space-y-2">
        {loading && <p className="text-sm text-zinc-500">Loading messages…</p>}
        {!loading && visible.length === 0 && (
          <p className="text-sm text-zinc-500" data-testid="messages-empty">
            {filter === "leads" ? "No leads flagged yet — tap the star on a message to mark it." : filter === "unread" ? "No unread messages." : "No messages yet."}
          </p>
        )}
        {!loading && visible.map((m) => (
          <MessageRow
            key={m.id}
            m={m}
            isOpen={openId === m.id}
            onToggleOpen={toggleOpen}
            onToggleLead={toggleLead}
            onSetRead={setRead}
            onRemove={remove}
          />
        ))}
      </div>
    </div>
  );
};

export default MessagesInbox;
